const props = {
  flowDealFlag:true,
  "contentConfigs": {
    "tCopyBtn": false,
    "tDelBtn": false,
    "styles": {},
    "label": "显示卡片",
    "componentKey": "xmCard",
    "baseConfig": false,
    "props": {"size": "miniCard", "width": "100%", "label": "显示卡片", "bordered": true, "key": "cddlbhcbsscg"}
  },
  "show": true,
  "label": "时间轴-审核日志",
  "showLabel": false,
  "rightSlotItem": {
    "adjustPosition": true,
    "focus": false,
    "label": "右侧插槽",
    "props": {"width": 130, "label": "右侧插槽", "key": "keyojchfmacssfhgnsscgoa_rightSlotItem"},
    "hasResize": false,
    "draggable": true,
    "children": [],
    "animations": [],
    "name": "右侧插槽",
    "styles": {},
    "showStyleConfig": true,
    "actions": [],
    "componentKey": "xmDiv",
    "key": "keyojchfmacssfhgnsscgoa_rightSlotItem",
    "_vid": "keyojchfmacssfhgnsscgoa_rightSlotItem"
  },
  "hasDefValue": false,
  "size": "middle",
  "bigScreen": true,
  "width": "100%",
  "isFormEl": true,
  "showType": "card",
  "position": "left",
  "paddingSize": "miniCard",
  "key": "keyojchfmacssfhgnsscgoa",
  "height": 'calc(100% - 44px)',
  "ctlId": "checkLog"
}


const styles = {"marginBottom": ""}

const events = []
const dataConfig = {
  "userDef": true,
  "groupType": "off",
  "domainCode": "TB_000000_308441752432279621_LCC_OPTION_LOG",
  "columns": [],
  "moduleName": "操作日志",
  "pageSize": 999999,
  "contentCols": [
    {
      "showBtns": "10",
      "controlType": "xmInput",
      "propId": "operation",
      "isCanEditor": false,
      "showToolTip": true,
      "propType": "xmInput",
      "propName": "处理意见",
      "showFlag": true,
      "hideLabel": false
    }
  ],
  "bottomCols": [{
    "showBtns": "10",
    "controlType": "xmInput",
    "propId": "currentProcessor",
    "isCanEditor": false,
    "propType": "xmInput",
    "propName": "处理人",
    "showFlag": true
  }],
  "selId": "",
  "xPointId": [],
  "dataSubFormType": "userDef",
  "templateContent": "",
  "moduleId": "1851091787547996162",
  "userDefUrl": true,
  "mainTitleColShow": true,
  "autoLoadData": true,
  "orderFieldList": [],
  "dataType": "xmTimeLine",
  "showDsTitle": false,
  "url": "/api/go-lcc/execute/pageByTableCode/TB_000000_308441752432279621_LCC_OPTION_LOG",
  "templateContentLabel": "",
  "queryUserParams": [],
  "waitSelCols": [],
  "headerCols": [{
    "showBtns": "10",
    "controlType": "DatePicker__withTime",
    "propId": "processingTime",
    "isCanEditor": false,
    "propType": "DatePicker__withTime",
    "propName": "处理时间",
    "showFlag": true
  }],
  "statusColShow": true,
  "useQueryUrl": "/api/go-lcc/lccSimpleFlowInstance/listHistory",
  "useQueryType": "GET",
  "readColList": [],
  "templateKey": "commonList",
  "lccQueryScopeType": "currentAccount"
}
export default computed(() => {
  return {
    codeCtl: true,
    dataConfig,
    props,
    elConfig: {props},
    styles,
    model: {"entityKey": "state", "key": "keyojchfmacssfhgnsscgoa"},
    events
  }
})

